import { createAction } from 'redux-actions';
import {
  PROCESSING,
  GET_CLIENT_DETAILS,
  GET_CLIENT_DETAILS_SUCCESS,
  GET_CLIENT_DETAILS_FAIL,
  SHOW_TERMS_OF_USE,
  SHOW_PRIVACY_POLICY,
  SHOW_FEEDBACK,
  SEND_MAIL,
  SEND_MAIL_SUCCESS,
  GET_SITE_COPY,
  GET_SITE_COPY_SUCCESS,
  CLIENT_DETAILS_FETCHING,
  GET_PROGRAMS_BY_TOPIC,
  GET_PROGRAMS_BY_TOPIC_SUCCESS,
  GET_THEMES,
  GET_THEMES_SUCCESS,
  GET_RESOURCES_COUNT_BY_TOPIC,
  GET_RESOURCES_COUNT_BY_TOPIC_SUCCESS,
  GET_CLIENT_RESOURCES,
  GET_CLIENT_RESOURCES_SUCCESS,
  SHOW_REGION_SELECTOR,
  SET_REGION,
  UPDATE_BRAND,
  SHOW_REGION_BANNER,
  CLEAR_CLIENT_DETAILS,
  SET_LANDING,
  SHOW_HOMEPAGE_PRO,
} from './constants';

export const processing = createAction(PROCESSING);
export const getClientDetails = createAction(GET_CLIENT_DETAILS);
export const getClientDetailsSuccess = createAction(GET_CLIENT_DETAILS_SUCCESS);
export const getClientDetailsFail = createAction(GET_CLIENT_DETAILS_FAIL);
export const clearClientDetails = createAction(CLEAR_CLIENT_DETAILS);
export const showTermsOfUse = createAction(SHOW_TERMS_OF_USE);
export const showPrivacyPolicy = createAction(SHOW_PRIVACY_POLICY);
export const showFeedback = createAction(SHOW_FEEDBACK);
export const sendMail = createAction(SEND_MAIL);
export const sendMailSuccess = createAction(SEND_MAIL_SUCCESS);
export const getSiteCopy = createAction(GET_SITE_COPY);
export const getSiteCopySuccess = createAction(GET_SITE_COPY_SUCCESS);
export const clientDetailsFetching = createAction(CLIENT_DETAILS_FETCHING);
export const getProgramsByTopic = createAction(GET_PROGRAMS_BY_TOPIC);
export const getProgramsByTopicSuccess = createAction(
  GET_PROGRAMS_BY_TOPIC_SUCCESS,
);
export const getThemes = createAction(GET_THEMES);
export const getThemesSuccess = createAction(GET_THEMES_SUCCESS);
export const getResourcesCountByTopic = createAction(
  GET_RESOURCES_COUNT_BY_TOPIC,
);
export const getResourcesCountByTopicSuccess = createAction(
  GET_RESOURCES_COUNT_BY_TOPIC_SUCCESS,
);
export const getClientResources = createAction(GET_CLIENT_RESOURCES);
export const getClientResourcesSuccess = createAction(
  GET_CLIENT_RESOURCES_SUCCESS,
);
export const showRegionSelector = createAction(SHOW_REGION_SELECTOR);
export const setRegion = createAction(SET_REGION);
export const updateBrand = createAction(UPDATE_BRAND);
export const showRegionBanner = createAction(SHOW_REGION_BANNER);
export const setLandingMenu = createAction(SET_LANDING);
export const showHomepagePro = createAction(SHOW_HOMEPAGE_PRO);
